import React from 'react';
import { MaintenanceModel } from './useMaintenanceData';
import { WINDOW_STATUS_COLORS } from './maintenanceTypes';

const MaintenanceWindows: React.FC<{ model: MaintenanceModel }> = ({ model }) => {
  const { activeWindows, pastWindows, handleUpdateWindowStatus, setDeleteConfirm } = model;
  return (
    <>
      {/* Active/Scheduled Maintenance Windows */}
      {activeWindows.length > 0 && (
        <div className="rp-bento-card mb-6">
          <h3 className="text-lg font-semibold mb-4" style={{ color: 'var(--rp-text)' }}>
            Active & Scheduled Maintenance
          </h3>
          <div className="space-y-3">
            {activeWindows.map(w => {
              const sc = WINDOW_STATUS_COLORS[w.status] || WINDOW_STATUS_COLORS.scheduled;
              return (
                <div key={w.id} className="p-4 rounded-lg" style={{ backgroundColor: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
                  <div className="flex justify-between items-start gap-4 flex-wrap">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1 flex-wrap">
                        <span className="font-semibold" style={{ color: 'var(--rp-text)' }}>{w.title}</span>
                        <span className="text-xs px-2 py-0.5 rounded-full capitalize" style={{ backgroundColor: sc.bg, color: sc.text }}>{w.status.replace('_', ' ')}</span>
                        {!w.is_published && (
                          <span className="text-xs px-2 py-0.5 rounded-full bg-gray-500/20 text-gray-400">Unpublished</span>
                        )}
                      </div>
                      {w.description && <p className="text-sm mb-2" style={{ color: 'var(--rp-text-secondary)' }}>{w.description}</p>}
                      <div className="flex gap-4 text-xs" style={{ color: 'var(--rp-text-tertiary)' }}>
                        <span>Start: {new Date(w.start_time).toLocaleString()}</span>
                        <span>End: {new Date(w.end_time).toLocaleString()}</span>
                      </div>
                      <div className="flex gap-1 mt-2 flex-wrap">
                        {w.affected_services.map(s => (
                          <span key={s} className="text-xs px-2 py-0.5 rounded-full capitalize" style={{ backgroundColor: 'rgba(255,255,255,0.1)', color: 'var(--rp-text-secondary)' }}>{s}</span>
                        ))}
                      </div>
                    </div>
                    <div className="flex gap-1 flex-wrap min-w-0">
                      {w.status === 'scheduled' && (
                        <button onClick={() => handleUpdateWindowStatus(w.id, 'in_progress')}
                          className="px-3 py-1.5 rounded-lg text-xs font-semibold"
                          style={{ backgroundColor: 'rgba(245,158,11,0.2)', color: '#f59e0b' }}
                        >
                          Start Now
                        </button>
                      )}
                      {w.status === 'in_progress' && (
                        <button onClick={() => handleUpdateWindowStatus(w.id, 'completed')}
                          className="px-3 py-1.5 rounded-lg text-xs font-semibold"
                          style={{ backgroundColor: 'rgba(16,185,129,0.2)', color: '#10b981' }}
                        >
                          Complete
                        </button>
                      )}
                      <button onClick={() => handleUpdateWindowStatus(w.id, 'cancelled')}
                        className="px-3 py-1.5 rounded-lg text-xs font-semibold"
                        style={{ backgroundColor: 'rgba(107,114,128,0.2)', color: '#6b7280' }}
                      >
                        Cancel
                      </button>
                      <button onClick={() => setDeleteConfirm(w.id)}
                        className="px-3 py-1.5 rounded-lg text-xs"
                        style={{ color: '#ef4444' }}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Past Maintenance Windows */}
      {pastWindows.length > 0 && (
        <div className="rp-bento-card mb-6">
          <h3 className="text-lg font-semibold mb-4" style={{ color: 'var(--rp-text)' }}>
            Past Maintenance ({pastWindows.length})
          </h3>
          <div className="space-y-2 max-h-64 overflow-y-auto">
            {pastWindows.slice(0, 20).map(w => {
              const sc = WINDOW_STATUS_COLORS[w.status] || WINDOW_STATUS_COLORS.completed;
              return (
                <div key={w.id} className="flex items-center justify-between p-3 rounded-lg gap-3" style={{ backgroundColor: 'rgba(255,255,255,0.03)' }}>
                  <div className="flex items-center gap-3 flex-wrap min-w-0">
                    <span className="text-xs px-2 py-0.5 rounded-full capitalize" style={{ backgroundColor: sc.bg, color: sc.text }}>{w.status}</span>
                    <span className="text-sm" style={{ color: 'var(--rp-text)' }}>{w.title}</span>
                    <span className="text-xs" style={{ color: 'var(--rp-text-tertiary)' }}>{new Date(w.start_time).toLocaleDateString()}</span>
                  </div>
                  <button onClick={() => setDeleteConfirm(w.id)}
                    className="text-xs px-2 py-1 rounded hover:bg-white/10"
                    style={{ color: '#ef4444' }}
                  >
                    Delete
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default MaintenanceWindows;
